import { Box, SimpleButton, Table } from 'edenred-ui';
import styled from 'styled-components';

export const StyledButton = styled(SimpleButton)`
  flex: 1;
  display: flex;
  font-size: ${({ theme }) => theme.sizeMedium};
  width: 100%;
`;

export const ActionButton = styled(Box)`
  opacity: 0;
  transition: opacity 0.15s ease;

  &:hover svg {
    fill: ${props => props.theme.primaryBackColorStrong};
  }
`;

export const BenefitIcons = styled(Box)`
  transition: opacity 0.15s ease;
`;

export const StyledRow = styled(Table.Row)`
  &:hover {
    background-color: ${props => props.theme.primaryBackColorLight10};

    ${ActionButton} {
      opacity: 1;
    }

    ${BenefitIcons} {
      opacity: 0;
    }
  }
`;

export const ButtonContent = styled.span`
  display: flex;
  align-items: center;

  svg {
    margin-right: 8px;
  }
`;
